import { FormDialog as HoaDonBanHangForm } from '@/features/ban-hang/hoa-don-ban-ra/hoa-don-ban-hang/components';
import { HoaDonBanHangSearchProvider } from '@/features/ban-hang/hoa-don-ban-ra/hoa-don-ban-hang/context';
import { buildDocumentFormRegistry, DocumentFormV2 } from '@/components/custom/erp';
import { QUERY_KEYS } from '@/constants';

interface Props {
  document_uuid: string;
  document_type: string;
  onClose: () => void;
  onSubmit?: (data: BanHangPayload) => void;
}

const DOCUMENT_FORM_REGISTRY = buildDocumentFormRegistry([
  {
    keys: 'HOA_DON_BAN_HANG',
    entry: {
      endpoint: QUERY_KEYS.HOA_DON_BAN_HANG,
      FormComponent: HoaDonBanHangForm,
      Provider: HoaDonBanHangSearchProvider
    }
  }
]);

export default function DocumentForm(props: Props) {
  return <DocumentFormV2 {...props} registry={DOCUMENT_FORM_REGISTRY} />;
}
